import {ReactComponent as Icon} from '@image/icon_menu.svg';

const iconMenu = () => {
    return   <Icon />;
};

export default iconMenu;